export const columnGap = {
  patterns: {
    number: '{{value}}',
    string: '{{value}}',
  },
  properties: 'columnGap',
};

export const gap = {
  patterns: {
    number: '{{value}}',
    string: '{{value}}',
  },
  properties: 'gap',
};

export const gridAutoFlow = {
  patterns: {
    'col-dense': 'col dense',
    column: 'column',
    dense: 'dense',
    inherit: 'inherit',
    initial: 'initial',
    row: 'row',
    'row-dense': 'row dense',
    unset: 'unset',
  },
  properties: 'gridAutoFlow',
};

export const gridColumn = {
  patterns: {
    auto: 'auto',
    full: '1 / -1',
    number: 'span {{value}} / span {{value}}',
    string: '{{value}}',
  },
  properties: 'gridColumn',
};

export const gridColumnEnd = {
  patterns: {
    number: '{{value}}',
    string: '{{value}}',
  },
  properties: 'gridColumnEnd',
};

export const gridColumnStart = {
  patterns: {
    number: '{{value}}',
    string: '{{value}}',
  },
  properties: 'gridColumnStart',
};

export const gridRow = {
  patterns: {
    auto: 'auto',
    full: '1 / -1',
    number: 'span {{value}} / span {{value}}',
    string: '{{value}}',
  },
  properties: 'gridRow',
};

export const gridRowEnd = {
  patterns: {
    number: '{{value}}',
    string: '{{value}}',
  },
  properties: 'gridRowEnd',
};

export const gridRowStart = {
  patterns: {
    number: '{{value}}',
    string: '{{value}}',
  },
  properties: 'gridRowStart',
};

export const gridTemplateColumns = {
  patterns: {
    number: 'repeat({{value}}, minmax(0, 1fr))',
    string: '{{value}}',
  },
  properties: 'gridTemplateColumns',
};

export const gridTemplateRows = {
  patterns: {
    number: 'repeat({{value}}, minmax(0, 1fr))',
    string: '{{value}}',
  },
  properties: 'gridTemplateRows',
};

export const rowGap = {
  patterns: {
    number: '{{value}}',
    string: '{{value}}',
  },
  properties: 'rowGap',
};
